export default __webpack_public_path__ + "static/media/completed-status.b8f0784a.svg";